import QuantityPicker from '@common/components/QuantityPicker';
import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { Section } from '@common/components/BookingForms';
import { GuestCounterLabel, GuestCounterWrapper } from './GuestCounter.styles';

export interface GuestCounterProps {
  quantity: number;
  setQuantity: (_: number) => void;
  incrementBy: number;
  maxGuests?: number;
  minGuests?: number;
}

const controlId = 'guest-quantity-picker';

export const GuestCounter: FC<GuestCounterProps> = ({
  quantity,
  setQuantity,
  incrementBy,
  maxGuests,
  minGuests,
}) => {
  const { t } = useTranslations();

  return (
    <Section>
      <GuestCounterWrapper>
        <GuestCounterLabel htmlFor={controlId}>{t('common.guests')}</GuestCounterLabel>
        <QuantityPicker
          controlId={controlId}
          input={{
            value: quantity,
            onChange: (val) => setQuantity(val),
          }}
          maxValue={maxGuests || Infinity}
          minValue={minGuests}
          isSmall={false}
          incrementBy={incrementBy}
          showZeroCounter
        />
      </GuestCounterWrapper>
    </Section>
  );
};
